import React from "react";

import "./styles.scss";

import Breadcrumbs from "../../assets/component/breadcrumbs";
import uris from "../../config/uris";
import SyncExternal from "./sync-external";

const SettingsMain = () => {
    const menuData = {
        title: "Settings",
        parentMenu: {
            name: "Settings",
            link: uris?.settings
        },
    }

    const sectionsConfig = [
        {
            key: 1,
            title: "Sync External Files",
            content: (<SyncExternal />)
        }
    ]

    return (
        <div className="settings-main">
            <Breadcrumbs breadcrumbDetails={menuData} />

            {sectionsConfig?.map((section) => (
                <div className="settings-section-wrapper" key={section?.key}>
                    <div className="section-title">{section?.title}</div>
                    <div className="section-contents">{section?.content}</div>
                </div>
            ))}
        </div>
    )
}

export default SettingsMain